import { Form } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;
`;
